import { Draggable, Droppable } from 'react-beautiful-dnd';
import { Question } from '../../../types';
import { EditableListItem, AddItemInput, TagsField } from '../../components';
import { useQuestionOptions } from '../../hooks';

interface OptionsBasedQuestionConfigProps {
  question: Question;
  onEdit: (questionId: string, updates: Partial<Question>) => void;
}

export function OptionsBasedQuestionConfig({
  question,
  onEdit,
}: OptionsBasedQuestionConfigProps) {
  const {
    newOption,
    isAddingOption,
    setNewOption,
    setIsAddingOption,
    addOption,
    cancelAddOption,
    removeOption,
    updateOption,
  } = useQuestionOptions({ question, onEdit });

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-600">
        Opções de resposta
      </label>

      <Droppable droppableId={`question-${question.id}-options`} type="option">
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps} className="space-y-2">
            {(question.options || []).map((option, idx) => (
              <Draggable
                key={`${question.id}-option-${idx}`}
                draggableId={`${question.id}-option-${idx}`}
                index={idx}
              >
                {(provided, snapshot) => (
                  <div ref={provided.innerRef} {...provided.draggableProps}>
                    <EditableListItem
                      value={option}
                      onChange={(value) => updateOption(idx, value)}
                      onRemove={() => removeOption(idx)}
                      dragHandleProps={provided.dragHandleProps}
                      isDragging={snapshot.isDragging}
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>

      <AddItemInput
        value={newOption}
        onChange={setNewOption}
        onAdd={addOption}
        onCancel={cancelAddOption}
        onToggle={() => setIsAddingOption(true)}
        placeholder="Nome da opção"
        buttonLabel="Nova opção"
        isVisible={isAddingOption}
      />

      <TagsField
        value={question.tags || []}
        onChange={(tags) => onEdit(question.id, { tags })}
      />
    </div>
  );
}
